import React from 'react';
import {
    Box,
    Heading,
    Text,
    VStack,
    Divider,
    useColorModeValue,
} from "@chakra-ui/react";

export default function Terms() {
    const headingColor = useColorModeValue("#f70112", "#ff4757");
    const textColor = useColorModeValue("gray.700", "gray.200");
    const bgColor = useColorModeValue("white", "gray.800");
    
    return (
        <Box
            bg={bgColor}
            borderRadius="lg"
            p={{ base: 4, sm: 6, md: 8 }}
            shadow="sm"
            border="1px"
            borderColor={useColorModeValue("gray.200", "gray.700")}
            mx={{ base: "10px", md: 0 }}
            my={{ base: 2, md: 4 }}
        >
                <VStack spacing={{ base: 6, md: 8 }} align="stretch">
                    <Box textAlign="center">
                        <Heading
                            as="h1"
                            size={{ base: "md", md: "lg" }}
                            color={headingColor}
                            mb={4}
                        >
                            Terms and Conditions
                        </Heading>
                        <Text color={textColor} fontSize={{ base: "md", md: "lg" }}>
                            Last updated: {new Date().toLocaleDateString()}
                        </Text>
                    </Box>

                    <Divider />

                    <VStack spacing={{ base: 4, md: 6 }} align="stretch">
                        <Box>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                These Terms and Conditions ("Terms") govern your access to and use of Tronweb Rentals services, 
                                including our website, mobile applications, and API services (collectively, the "Services"). 
                                By accessing or using our Services, you agree to be bound by these Terms.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                1. Acceptance of Terms
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" mb={3} fontSize={{ base: "sm", md: "md" }}>
                                By using Tronweb Rentals, you acknowledge that you have read, understood, and agree to be bound by these Terms. 
                                If you do not agree to these Terms, please do not use our Services.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                2. Eligibility
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" mb={3} fontSize={{ base: "sm", md: "md" }}>
                                To use our Services, you must:
                            </Text>
                            <VStack spacing={2} align="stretch" pl={{ base: 3, md: 4 }}>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Be at least 18 years of age</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Have the legal capacity to enter into binding agreements</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Not be located in a jurisdiction where cryptocurrency services are prohibited</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Comply with all applicable laws and regulations</Text>
                            </VStack>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                3. Service Description
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                Tronweb Rentals provides a platform for TRON resource rental services, including energy and bandwidth rental, 
                                staking services, and related cryptocurrency operations. Our Services are provided on an "as-is" basis.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                4. User Responsibilities
                            </Heading>
                            <VStack spacing={2} align="stretch" pl={{ base: 3, md: 4 }}>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Maintain the security of your account credentials</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Provide accurate and complete information</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Comply with all applicable laws and regulations</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Not engage in fraudulent, illegal, or unauthorized activities</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Use only authorized interfaces and API keys for transactions</Text>
                            </VStack>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                5. Account Security
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                You are solely responsible for maintaining the confidentiality of your account information and for all activities 
                                that occur under your account. We reserve the right to suspend or terminate accounts that engage in suspicious or 
                                unauthorized activities.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                6. Risk Disclosure
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" mb={3} fontSize={{ base: "sm", md: "md" }}>
                                Cryptocurrency transactions involve inherent risks, including but not limited to:
                            </Text>
                            <VStack spacing={2} align="stretch" pl={{ base: 3, md: 4 }}>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Market volatility and price fluctuations</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Technical issues or system downtime</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Regulatory changes</Text>
                                <Text color={textColor} fontSize={{ base: "sm", md: "md" }}>• Cyber security threats</Text>
                            </VStack>
                            <Text color={textColor} lineHeight="1.8" mt={3} fontSize={{ base: "sm", md: "md" }}>
                                You acknowledge and accept these risks when using our Services.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                7. Limitation of Liability
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                To the maximum extent permitted by law, Tronweb Rentals shall not be liable for any indirect, incidental, 
                                special, consequential, or punitive damages, including but not limited to loss of profits, data, or other 
                                intangible losses resulting from your use of our Services.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                8. Privacy and Data Protection
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                We may collect, use, and disclose your personal information as described in our Privacy Policy. 
                                We may disclose account information when required by law, court order, or to protect the security 
                                and integrity of our Services.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                9. Force Majeure
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                We shall not be liable for any delays, failures, or interruptions in our Services resulting from 
                                circumstances beyond our reasonable control, including but not limited to natural disasters, 
                                cyber attacks, government actions, or technical failures.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                10. Modifications
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                We reserve the right to modify these Terms at any time. Updated Terms will be posted on our website 
                                with the effective date. Your continued use of our Services constitutes acceptance of the revised Terms.
                            </Text>
                        </Box>

                        <Box>
                            <Heading as="h2" size={{ base: "sm", md: "md" }} color={headingColor} mb={4}>
                                11. Contact Information
                            </Heading>
                            <Text color={textColor} lineHeight="1.8" fontSize={{ base: "sm", md: "md" }}>
                                If you have any questions about these Terms, please contact us through our official communication channels.
                            </Text>
                        </Box>
                    </VStack>

                </VStack>
        </Box>
    );
}
